import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://cashew-nuts-server-production.up.railway.app',
    }),
    tagTypes: ['Search', 'CategoryData', 'Allproduct', 'SlideShowData', 'SingleProduct', 'SimilarProduct', 'RecentViewedProduct'],
    endpoints: (builder) => ({
        getproducts: builder.query({
            query: () => ({
                url: '/api/v1/getAllProduct',
                method: 'GET',
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                },
            }),
            providesTags: ["Allproduct"],
        }),
        getSearchData: builder.query({
            query: ({ searchValue, page }) => {
                return ({
                    url: `/api/v1/search-item/${searchValue}/${page}`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                    }
                })
            },
            // providesTags: ['Search']
        }),

        categoryData: builder.query({
            query: ({ type, page }) => {
                return (
                    {

                        url: `/api/v1/categories/${type}/${page}`,
                        headers: {
                            'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                        },
                    }
                )
            },
            providesTags: ['CategoryData']
        }),
        slideShowData: builder.query({
            query: () => '/slide-show-data',
            providesTags: ['SlideShowData']
        }),

        singleProduct: builder.query({
            query: ({ type, id }) => {
                return (
                    {
                        url: `/api/v1/singleProduct/${type}/${id}`,
                        headers: {
                            'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                        },
                    }
                )
            },
            providesTags: ['SingleProduct']
        }),
        getSimmilarProduct: builder.query({
            query: (type) => ({
                url: `/api/v1/similar-product/${type}`,
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                },
            }),
            headers: { 'authorization': `Bearer ${localStorage.getItem('cashew-token')}` },
            providesTags: ['SimilarProduct']
        }),
        recentViewedProduct: builder.mutation({
            query: (recentKey) => ({
                url: '/api/v1/recent-product',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                },
                body: JSON.stringify({ recentKey })
            }),
            // providesTags: ['RecentViewedProduct'],
        }),
        getMyorder: builder.query({
            query: (email) => ({
                url: `/api/v1/my-orders?email=${email}`,
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                },
            })
        }),
        trackOrderData: builder.query({
            query: ({ trackId, orderId }) => ({
                url: `/api/v1/${trackId}/${orderId}`,
                method: 'GET',
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('cashew-token')}`
                }
            }),
        }),
        createPaymentIntent: builder.query({
            query: (total) => ({
                url: '/create-payment-intent',
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({ total })
            })
        })
    })
})

export const { useGetSearchDataQuery, useCategoryDataQuery, useGetproductsQuery, useSlideShowDataQuery, useSingleProductQuery, useGetSimmilarProductQuery, useRecentViewedProductMutation, useGetMyorderQuery, useTrackOrderDataQuery, useCreatePaymentIntentQuery } = apiSlice;
